import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StatusListComponent } from './status-list/status-list.component';
import { AddEditStatusComponent } from './add-edit-status/add-edit-status.component';
import { StatusTypeListComponent } from './status-type/status-type-list/status-type-list.component';
import { AssignStatusComponent } from './status-type/assign-status/assign-status.component';

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    component: StatusListComponent
  },
  {
    path: "add-status",
    pathMatch: "full",
    component: AddEditStatusComponent
  },
  {
    path: "edit-status/:statusId",
    pathMatch: "full",
    component: AddEditStatusComponent
  },
  {
    path: "status-types",
    pathMatch: "full",
    component: StatusTypeListComponent
  },
  {
    path: "assign-status/:statusTypeId",
    pathMatch: "full",
    component: AssignStatusComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StatusManagementRoutingModule { }
